module.exports = __webpack_public_path__ + "static/media/bg.acca7f39.png";